(function(){
  if(window.__ti_nl_init)return;
  window.__ti_nl_init=true;
  var API='https://trust-logistics.vercel.app/api/newsletter/subscribe';
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||form.getAttribute('is')!=='newsletter-form')return;
    var inp=form.querySelector('input[type="email"]');
    if(!inp||!inp.value)return;
    var email=inp.value.trim();
    if(!email)return;
    e.preventDefault();
    e.stopPropagation();
    var btn=form.querySelector('button[type="submit"]');
    if(btn)btn.disabled=true;
    fetch(API,{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({email:email}),
      mode:'cors'
    })
    .then(function(r){return r.json()})
    .then(function(data){
      if(btn)btn.disabled=false;
      var modal=form.querySelector('.modal--newsletter-alert');
      if(modal){
        modal.removeAttribute('hidden');
        var body=modal.querySelector('.drawer__body');
        if(body){
          body.innerHTML='<p class="form-message form-message--main alert alert--success blocks-radius h6 w-full" tabindex="-1" autofocus>'
            +'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256"><path fill="currentColor" d="M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z"></path></svg>'
            +'Merci pour votre inscription !'
            +(data.discountCode?'<br><span style="font-weight:700;margin-top:6px;display:inline-block">Votre code : '+data.discountCode+' (-'+data.discountPercent+'%)</span>':'')
            +'</p>';
        }
      }
    })
    .catch(function(){
      if(btn)btn.disabled=false;
      form.submit();
    });
  },true);
})();